<template>
  <b-row class="below">
    <b-col sm="2" lg="2">동영상</b-col>
    <b-col>
      <b-container>
        <b-row :key="v.id" v-for="v in videos">
          <b-col sm="6" lg="6">{{ v.link }}</b-col>
          <b-col sm="3" lg="3">{{ v.video_from }}</b-col>
          <b-col sm="3" lg="3">{{ v.video_to }}</b-col>
        </b-row>
      </b-container>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: ["videos"],
  computed: {},
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.below {
  border-bottom: 1px dashed $gray600;
  margin-top: 4px;
  margin-bottom: 4px;
}
</style>